import { SxProps } from 'theme-ui';
import { Box } from '@themed';
import { ChildrenProps } from '@types';

export const PostContentContainer = ({ children, sx }: ChildrenProps & SxProps) => (
  <Box sx={{ variant: 'styles.blogTextMaxWidth', ...sx }}>
    {children}
  </Box>
);
